<template>
  <div>
    <el-dialog custom-class="email-enter-title-window" :close-on-click-modal="false" :visible.sync="innerVisible" width="420px" :title="$t('Clearing.SendEmail')" @close="innerVisible=false">
      <div>
        <span> {{ rowData.length === 0?$t('Clearing.N1ContactAndEmailMaintained'):$t('Clearing.N1AMaintainedContactEmail') }}</span>
        <el-checkbox v-model="cc" no="cc" style="padding-left: 20px" @change="ccChangeHandler">{{ $t('CargoMsg.Cargo_SendCc') }}</el-checkbox>
      </div>
      <div class="app-main-inner-row">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :style="{width:'380px',height:'150px'}"
        />
      </div>
      <div style="padding-top: 55px;">
        <el-form>
          <el-form-item>
            <span>{{ $t('Clearing.N2PleaseAddOtherEmails') }}</span><span>{{ $t('Clearing.MultipleShouldBeSeparatedCommas') }}</span>
          </el-form-item>
          <el-form-item class="el-form-item-textarea">
            <el-input v-model="mailInpuTextArea" no="1" type="textarea" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <span>
          <el-button no="2" type="primary" @click="sendButtonClick">{{ $t('Clearing.Send') }}</el-button>
          <el-button no="3" @click="closeHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { getContacts } from '@/api/partner/contact'
import { sendEmail } from '@/api/clearing/invoice'
import { getGridSelected } from '@/utils/agGrid'
import StrUtils from '@/utils/StrUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export default {
  name: 'EmailEnterTitleWindow',
  props: {
    visible: { type: Boolean, required: true },
    invoiceKey: { type: String, required: true },
    accountId: { type: Number, required: true, default: 0 }
  },
  data() {
    return {
      loading: false,
      innerVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCopyRowsToClipboard: true,
        suppressRowSelection: true,
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.ccChangeHandler()
        }
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [
        { headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true },
        { headerName: this.$t('CargoMsg.Cargo_Contact'), field: 'contactPerson', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_email'), field: 'email', width: 200 }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      cc: false,
      mailInpuTextArea: ''
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      const ccItem = LocalStorageUtilsNew.getConfiguration('emailEnterTitleWindow-defaultCC')
      if (ccItem) {
        this.cc = ccItem
      } else {
        this.cc = false
      }
      this.toQuery()
    }
  },
  mounted() {

  },
  methods: {
    toQuery() {
      if (!this.invoiceKey) {
        this.$message.warning(this.$t('Clearing.InvoiceUuidCannotBeEmpty'))
        return
      }
      if (this.accountId === 0) {
        this.$message.warning(this.$t('Clearing.SettlementIdCannotBeEmpty'))
        return
      }
      this.loading = getLoading()
      getContacts({ cmpIdx: this.accountId }).then(res => {
        this.rowData = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    ccChangeHandler() {
      if (this.cc) {
        const contacts = getGridSelected(this.gridOptions)
        let ccEmail = ''
        for (const contact of contacts) {
          if (!StrUtils.isEmpty(contact.ccAddress)) {
            ccEmail += (StrUtils.isEmpty(ccEmail) ? '' : ',') + contact.ccAddress
          }
        }
        this.mailInpuTextArea = ccEmail
      }
      LocalStorageUtilsNew.setConfiguration('emailEnterTitleWindow-defaultCC', this.cc)
    },
    // 发送
    sendButtonClick() {
      const contacts = getGridSelected(this.gridOptions)
      let mailStr = '' // this.mailInpuTextArea
      for (const contact of contacts) {
        if (!StrUtils.isEmpty(contact.email)) {
          mailStr += (StrUtils.isEmpty(mailStr) ? '' : ',') + contact.email
        }
      }
      const mailInput = this.mailInpuTextArea.replace(/[\r\n]/g, '')
      if (!StrUtils.isEmpty(mailInput)) {
        mailStr += (StrUtils.isEmpty(mailStr) ? '' : ',') + mailInput
      }
      mailStr = mailStr.replace(/\ +/g, '').replace('，', ',')
      console.log('sendButtonClick', mailStr)
      if (StrUtils.isEmpty(mailStr)) {
        this.$confirm(this.$t('Clearing.PleaseEnterEmail'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          return
        }).catch(() => { })
        return
      }
      //
      this.loading = getLoading()
      sendEmail({ 'invoiceKey': this.invoiceKey, 'emailString': mailStr }).then(res => {
        if (res.data) {
          this.$emit('sendEmailSuccess', this.invoiceKey)
        }
        console.log('sendEmail', res.data)
        this.$confirm(this.$t('CargoMsg.Cargo_Sent'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'success'
        }).then(() => {
          this.closeHandler()
        }).catch(() => {})
      }).finally(() => {
        this.loading.close()
      })
    },
    // 取消
    closeHandler() {
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss">
.email-enter-title-window {
  .el-form-item-textarea {
    width: 380px;
    padding-left: 10px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 380px;
      .el-textarea__inner {
        padding: 2px 4px;
        height: 40px;
        resize:none;
      }
    }
  }
}
</style>
